/* ============================================================
   SST — Quick View
   Opens a modal with product details + variant pills + Dawn
   <product-form> Add-to-Cart (which opens the cart drawer).
   Content fetched via the Section Rendering API:
     {product.url}?section_id=sst-quickview
   ============================================================ */
(function () {
  'use strict';

  var SECTION_ID = 'sst-quickview';
  var modal, body, loading, lastFocus, scrollY = 0;

  /* Lock the page scroll without losing position (fixes jump on close). */
  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + scrollY + 'px';
    document.body.classList.add('sst-no-scroll', 'sst-scroll-locked');
  }
  function unlockScroll() {
    document.body.classList.remove('sst-no-scroll', 'sst-scroll-locked');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  function init() {
    modal = document.querySelector('[data-sst-qv-modal]');
    if (!modal) return;
    body = modal.querySelector('[data-sst-qv-body]');
    loading = modal.querySelector('[data-sst-qv-loading]');

    // Open
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-sst-quickview]');
      if (!trigger) return;
      e.preventDefault();
      var url = trigger.getAttribute('data-product-url');
      if (url) open(url, trigger);
    });

    // Close
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-sst-qv-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    // Variant pill selection (delegated to injected content)
    body.addEventListener('click', function (e) {
      var pill = e.target.closest('.sst-qv__pill');
      if (pill) selectPill(pill);
    });

    // Close the quick-view when Dawn publishes a cart update (item added),
    // so the cart drawer Dawn opens is visible. Uses Dawn's pub/sub (pubsub.js).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, close);
    }
  }

  function open(url, trigger) {
    lastFocus = trigger;
    body.querySelectorAll('[data-sst-quickview-content]').forEach(function (n) { n.remove(); });
    if (loading) loading.hidden = false;
    modal.hidden = false;
    lockScroll();

    var fetchUrl = url.split('?')[0] + '?section_id=' + SECTION_ID;
    fetch(fetchUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-sst-quickview-content]');
        if (loading) loading.hidden = true;
        if (!content) { body.innerHTML = '<p class="sst-qv__fail">Could not load product.</p>'; return; }
        body.appendChild(content);
        // <product-form> is defined globally (product-form.js in theme head);
        // the injected element upgrades automatically.
      })
      .catch(function () {
        if (loading) loading.hidden = true;
        body.innerHTML = '<p class="sst-qv__fail">Could not load product.</p>';
      });
  }

  function close() {
    if (modal.hidden) return;
    modal.hidden = true;
    unlockScroll();
    // preventScroll stops the browser scrolling the trigger card into view,
    // which was jumping the page/gallery on close.
    if (lastFocus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); } }
  }

  /* Variant pills → resolve selected option combination to a variant id. */
  function selectPill(pill) {
    var group = pill.closest('.sst-qv__option');
    group.querySelectorAll('.sst-qv__pill').forEach(function (p) { p.classList.remove('is-active'); });
    pill.classList.add('is-active');
    resolveVariant();
  }

  function resolveVariant() {
    var wrap = body.querySelector('[data-sst-qv-options]');
    if (!wrap) return;
    var variants;
    try { variants = JSON.parse(wrap.getAttribute('data-variants')); } catch (e) { return; }

    var chosen = [];
    wrap.querySelectorAll('.sst-qv__option').forEach(function (opt) {
      var active = opt.querySelector('.sst-qv__pill.is-active');
      chosen.push(active ? active.getAttribute('data-value') : null);
    });

    var match = variants.find(function (v) {
      return chosen.every(function (val, i) { return val == null || v.options[i] === val; });
    });

    var idInput = body.querySelector('[data-sst-qv-variant-id]');
    var atc = body.querySelector('.sst-qv__atc');
    var atcText = body.querySelector('[data-sst-qv-atc-text]');
    if (match && idInput) {
      idInput.value = match.id;
      if (atc) atc.disabled = !match.available;
      if (atcText) atcText.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      updatePrice(match);
    }
  }

  function updatePrice(variant) {
    var priceEl = body.querySelector('.sst-qv__price .price-item--regular, .sst-qv__price .price-item');
    if (priceEl && variant.price != null) {
      priceEl.textContent = formatMoney(variant.price);
    }
  }

  function formatMoney(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) || '£{{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
